import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import SettingsIcon from '@material-ui/icons/Settings';
import '../../assets/css/Calendar.css';
import OffileDb from '../../config/pouchDB';

import Grid from "@material-ui/core/Grid";
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@material-ui/icons/ThumbDownAltOutlined';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Calendardatepickerpopup from "./Calendardatepickerpopup.js";
import Calendartimepicker from "./Calendartimepicker.js";
import Reminderselect from "./Reminderselect.js";
import Fab from '@material-ui/core/Fab';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function FullScreenDialog(props) {
  const { t } = props;
  const { templateID } = props;
  let bgStyles = templateID == 2 ? { color: "#fff", background: props.componentbgcolor } : {};
  let colorStyles = templateID == 2 ? { color: props.componentbgcolor } : {};
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [firstBleeding, setFirstBleeding] = React.useState(new Date());
  const [reminderTime, setreminderTime] = React.useState(new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds());
  const [reset, setreset] = React.useState(false);
  const [reminderType, setreminderType] = React.useState(1);
  const [userCalenderRemainderInfo, setUserCalenderRemainderInfo] = React.useState(null);
  const [isLoading, setisLoading] = React.useState(true);
  const [editRemainderObj, seteditRemainderObj] = React.useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const resetCalender = () => {
    console.log('reset')
    props.resetCalender()
  };


  const changeMode = () => {
    props.changeMode()
  }

  const setTime = () => {
    props.setTime()
  };

  const onDateChange = (date) => {
    setFirstBleeding(date)
    props.onDateChange(date)
  };

  const onTimeChange = (time) => {
    setreminderTime(time)
    props.onTimeChange(time)
  };

  const onTypeChange = (type) => {
    setreminderType(type)
    props.onTypeChange(type)
  };



  return (
    <div>
      {
        templateID == 1 ? (
          <Fab color="primary" aria-label="add" onClick={handleClickOpen}>
          <SettingsIcon />
        </Fab>
        ) : (
          <Button variant="outlined" color="primary" onClick={handleClickOpen} className="settingicon">
          <SettingsIcon></SettingsIcon>
        </Button>
        )
      }

      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>

            <Typography variant="h6" className={classes.title}>
              Settings
            </Typography>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Grid container spacing={3} className="gridcontainer">
          <div className="calendartabmainholder">
            <Grid container spacing={3} className="gridcontainer">
              <Grid item xs={12} >
                <Card className="border-grey mt-10px">
                  <CardContent className="zero informationcardholder">
                    <p className={templateID == 1 ? "getknwtitle text-left" : "zero settingcardheader"} style={colorStyles}>{t("Reset Pill Tracker")}</p>
                    <p className={templateID == 1 ? "getknwsubtitle text-left" : "zero p-10px"}>{t("Do you want to reset pill tracker with this as your first date?")}</p>
                    <p className="zero p-10px">
                      <Calendardatepickerpopup onDateChange={(date) => { onDateChange(date) }}></Calendardatepickerpopup>
                    </p>
                    <p className={templateID == 1 ? "p-10px pb-15px" : "zero p-10px pb-15px"}>
                      <Button variant="contained" className={templateID == 1 ? "login_btn" : ''} style={bgStyles} onClick={() => { resetCalender() }}>{t("Reset")}</Button>
                    </p>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} >
                <Card className="border-grey">
                  <CardContent className="zero informationcardholder">
                    <p className={templateID == 1 ? "getknwtitle text-left" : "zero settingcardheader"} style={colorStyles}>{t("Reset Reminder Time")}</p>
                    <p className={templateID == 1 ? "getknwsubtitle text-left" : "zero p-10px"}>{t("This is the time we will remind you for taking your pills!")}</p>
                    <p className="zero p-10px">
                      <Calendartimepicker onTimeChange={(time) => { onTimeChange(time) }}></Calendartimepicker>
                    </p>
                    <p className={templateID == 1 ? "p-10px pb-15px" : "zero p-10px pb-15px"}>
                      <Button variant="contained" className={templateID == 1 ? "login_btn" : ''} style={bgStyles} onClick={() => { setTime() }}>{t("Set Time")}</Button>
                    </p>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} >
                <Card className="border-grey mb-20px">
                  <CardContent className="zero informationcardholder">
                    <p className={templateID == 1 ? "getknwtitle text-left" : "zero settingcardheader"} style={colorStyles}>{t("Reset Reminder Type")}</p>
                    <p className={templateID == 1 ? "getknwsubtitle text-left" : "zero p-10px"}>{t("You'll be reminded via this mode of notification!")}</p>
                    <p className="zero p-10px">
                      <Reminderselect onTypeChange={(type) => { onTypeChange(type) }}></Reminderselect>
                    </p>
                    <p className={templateID == 1 ? "p-10px pb-15px" : "zero p-10px pb-15px"}>
                      <Button variant="contained" className={templateID == 1 ? "login_btn" : ''} style={bgStyles} onClick={() => { changeMode() }}>{t("Change Mode")}</Button>
                    </p>
                  </CardContent>
                </Card>
              </Grid>

            </Grid>
          </div>

        </Grid>
      </Dialog>
    </div>
  );
}


function mapStateToProps(state) {
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : state.storeState.templateID,
    communityuid: state.storeState.communityId,
    langId: state.storeState.langId,
    componentbgcolor: state.storeState.componentbgcolor
  };
}

export default connect(mapStateToProps)(withTranslation()(FullScreenDialog));